import React, { ReactNode, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

interface AlertPortalProps {
    children: ReactNode;
}

const AlertPortal: React.FC<AlertPortalProps> = ({ children }) => {
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
        return () => setMounted(false);
    }, []);

    if (!mounted) return null;

    const portalRoot = document.getElementById('alert-portal');
    if (!portalRoot) {
        console.warn('AlertPortal: Could not find element with id "alert-portal"');
        return null;
    }

    return createPortal(children, portalRoot);
};

export default AlertPortal;